/**
 * MODULES STORE
 */

import Vue from "vue";
import api from "Api";
import router from "Router";

const state = {
    currentRoute: localStorage.getItem("currentRoute") || null,
    modules: JSON.parse(localStorage.getItem("modules")) || null,
    rules_permission_modules: {
        module: {
            name: "module",
            rules: "trim|max_length[100]|required|regex_match[a-z_]",
            max_len: "100",
            min_len: "",
            default_value: "",
        },
    },
    rules_permission_function: {
        permission: {
            name: "permission",
            rules: "trim|max_length[200]|required|regex_match[a-z_]",
            max_len: "200",
            min_len: "",
            default_value: "",
        },
        permission_token: {
            name: "permission_token",
            rules: "trim|max_length[100]|required",
            max_len: "100",
            min_len: "",
            default_value: "index",
        },
        method: {
            name: "method",
            rules: "trim|max_length[6]|required",
            max_len: "6",
            min_len: "",
            default_value: "",
        },
        exempt: {
            name: "exempt",
            rules: "trim|max_length[1]|integer|required",
            max_len: "1",
            min_len: "",
            default_value: "",
        },
    },
};

// getters
const getters = {
    modules: (state) => {
        return state.modules;
    },
    permissions: (state) => {
        return state.permissions;
    },
    currentRoute: (state) => {
        return state.currentRoute;
    },
};

// actions
const actions = {
    async fetchModules({ rootState, commit }, payload) {
        try {
            let body = ""; // language: rootState.authStore.currentLocale.locale

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;
            /*let message = {
                html: '',
                type: '',
                icon: 'fa-warning',
                timeout: 2500,
            }*/

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitModule", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitModule", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateModule", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
};

// mutations
const mutations = {
    commitModule(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateModule(state, payload) {
        if (payload.method == "post" && payload.with) {
            // allows to find path with depth
            let property = _.get(state, payload.property);
            _.set(state, `${payload.property}[${(property || []).length}]`, payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_id = payload.id ? payload.id : payload.with[payload.pk];
            let property = _.get(state, payload.property);
            let curr_item = property[property.findIndex((obj) => obj[payload.pk] == curr_id)];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            let property = _.get(state, payload.property);
            property.splice(
                property.findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
            _.set(state, payload.property, property.length ? property : null);
        }
    },
    updateCurrentRoute(state, route) {
        state.currentRoute = route;
    },
    resetPermissions(state) {
        state.currentRoute = JSON.parse(localStorage.getItem("currentRoute")) || null;
        state.modules = JSON.parse(localStorage.getItem("modules")) || null;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
